export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11798.a05894e2.jpg";